// extracted by mini-css-extract-plugin
export default {"header":"vIa84Vlk","mobile":"mobile","fullwidth":"O37EVw5x","headerLeft":"GcqCe2cW","promo":"wCT3yFmm","controls":"MxGKmCAN","overlay":"Xq3mV0Xl"};